import httpClient from './httpClient';


const generalSettingService = {
    getGeneralSetting() {
        return httpClient.get( `/api/configurations` );
    }
}

export default generalSettingService;
